import {
    TRACK_ABTESTING,
    NON_APPLICABLE,
    TRACK_RECO_NO_RECO,
    TRACK_TRAFFIC_SOURCES,
    TRACK_SIZE_RECO_NO_RECO,
} from '@client/config/constants';
import {
    isClient,
    getCurrencyCode,
} from './';

// analytics, push into dataLayer:
export function track(type, payload) {
    const trackingInfo = { event: type };

    if (typeof payload === 'object') {
        Object.assign(trackingInfo, payload);
    }
    if (typeof payload === 'string') {
        Object.assign(trackingInfo, { data: payload });
    }

    // redux analytics expects a type param, but gtm expects an campaign param, so rename it.
    return isClient() && window.dataLayer && window.dataLayer.push(trackingInfo);
}

export const getTrackingForTrafficSource = (urlParams) => {
    const trafficSource = urlParams && urlParams.trafficSource;

    if (trafficSource && TRACK_TRAFFIC_SOURCES.includes(trafficSource)) {
        return { component: trafficSource };
    }

    return {};
};

function constructBannerDataObject({ banner, position }) {
    return {
        id: banner.id,
        name: banner.id,
        position: `slot${position}`,
        creative: (banner.id === 'newsletter_resignup') ? 'banner1' : 'banner2'
    };
}

export function getRecoImpressionData(articles, recoSource, appdomain) {
    const products = articles.map(article => {
        return {
            name: article.nameCategoryTag || NON_APPLICABLE,
            id: article.sku,
            price: article.specialPrice ? article.specialPrice / 100 : 0,
            brand: article.brand,
            category: article.silhouette ? article.silhouette : NON_APPLICABLE,
            variant: article.nameColor ? article.nameColor : NON_APPLICABLE,
            list: 'reco', // as requested by BI for just reco becasue they comes with no campaignId
            position: article.position ? article.position : 1,
            dimension1: NON_APPLICABLE,
            dimension2: (article.gender && article.gender.toString()) || NON_APPLICABLE,
            dimension3: article.brandCode ? article.brandCode : NON_APPLICABLE,
            dimension4: article.campaignIdentifier,
            dimension5: recoSource || article.source || TRACK_RECO_NO_RECO, // PDP(collaborative or top seller) OR Campaign Overview(mylounge), Default to no source
            dimension54: article.brand ? article.brand : NON_APPLICABLE
        };
    });

    const trackingData = {
        ecommerce: {
            currencyCode: getCurrencyCode(appdomain),
            impressions: products
        }
    };

    return trackingData;
}

export function getTrackingDataRemoveFromCart({ cartItem }) {
    const gender = Array.isArray(cartItem.gender) ? cartItem.gender.join(',') : cartItem.gender;

    return {
        ecommerce: {
            remove: {
                products: [{
                    name: cartItem.name,
                    id: cartItem.configSku,
                    price: cartItem.price,
                    brand: cartItem.brand,
                    category: cartItem.nameCategoryTag,
                    variant: cartItem.nameColor,
                    quantity: 1,
                    dimension1: cartItem.size,
                    dimension2: gender || 'N/A',
                    dimension3: cartItem.brandCode,
                    dimension4: cartItem.campaignIdentifier,
                    dimension5: cartItem.reco,
                    dimension54: 'N/A',
                }]
            }
        }
    };
}

export function getTrackingDataProductClick(article, position, recoSource = 0, specialPrice) {
    const trackingData = {
        ecommerce: {
            click: {
                actionField: { list: article.brand },
                products: [{
                    name: article.nameCategoryTag ? article.nameCategoryTag : 'N/A',
                    id: article.sku,
                    price: article.specialPrice ? article.specialPrice / 100 : specialPrice / 100,
                    brand: article.brand,
                    category: article.nameCategoryTag ? article.nameCategoryTag : 'N/A',
                    variant: article.nameColor ? article.nameColor : 'N/A',
                    position,
                    dimension1: 'N/A',
                    dimension2: (article.gender && article.gender.toString()) || 'N/A',
                    dimension3: article.brandCode ? article.brandCode : 'N/A',
                    dimension4: article.campaignIdentifier,
                    dimension5: recoSource,
                    dimension54: article.brand
                }]
            }
        }
    };

    return trackingData;
}

export function getBannerImpressionData(data) {
    const promotion = constructBannerDataObject(data);

    const trackingData = {
        ecommerce: {
            promoView: {
                promotions: [promotion]
            }
        }
    };

    return trackingData;
}

export function getBannerClickData(data) {
    const promotion = constructBannerDataObject(data);
    const trackingData = {
        ecommerce: {
            promoClick: {
                promotions: [promotion]
            }
        }
    };

    return trackingData;
}

export const getAbtestingTrackData = (experiment) => {
    const { variant, feedbackId, mode, id, assignmentKey } = experiment;
    const ASSIGNMENT_KEY_TO_TRACKUSER = {
        customerHash: 'visitorID',
        clientid: 'clientID',
    };

    track(TRACK_ABTESTING, {
        octopus_testName: id,
        octopus_variantName: variant,
        octopus_feedbackID: feedbackId,
        octopus_mode: mode,
        ...(assignmentKey && {
            [ASSIGNMENT_KEY_TO_TRACKUSER[assignmentKey.key]]: assignmentKey.value
        })
    });
};
